import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="gym-floor relative w-full text-white" data-id="element-59" data-mp="1zyh2w7skw2x2">
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-60" data-mp="1uy2vmryswx03" />
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-61" data-mp="1v0fmjumjehpa">
        <h2 className="font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-62" data-mp="1pyq9yajo1vz3">
          Stop planning the night before. <span className="text-amber" data-id="element-63" data-mp="1l29m7hgdpjmj">Start walking in ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-64" data-mp="1g7vov9i5p2f8">
          Six volumes, 52 weekly sessions and five bonuses. A full year of
          volleyball — serving, passing, setting, hitting, blocking and defense,
          every drill at three levels, print-ready and ready to run.
        </p>

        <div className="mt-7" data-id="element-65" data-mp="128vy9wb32dgf">
          <Countdown size="sm" tone="dark" data-id="element-66" data-mp="xakmhg189svk" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber bg-ink-deep/60 px-5 py-4 text-left" data-id="element-67" data-mp="xb4754i9ivda">
          <div data-id="element-68" data-mp="40zg3arpo7gf">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-amber" data-id="element-69" data-mp="41izyx0x95x3">Complete package</span>
            <span className="text-[15px] font-semibold text-white" data-id="element-70" data-mp="3lj25kb1nx48r">52 Weeks of Volleyball Practice Plans — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-71" data-mp="hzz72p2p4yfr">
            <span className="text-[15px] text-white/60 line-through" data-id="element-72" data-mp="hyfnoplqu79r">$97</span>
            <span className="font-display text-4xl font-extrabold leading-none text-white" data-id="element-73" data-mp="mz3dj7y8ki2e">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-74" data-mp="84p15q96g6wp">
          <CtaButton data-id="element-75" data-mp="d0e7ccfpcm1z">Yes, I want to walk in ready — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-76" data-mp="2ss20dwrlhufi">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-77" data-mp="148o43pffsmga">
              <span className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-78" data-mp="1484ncc1iw43u" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}